import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async get(id) {
    const url = process.env.VUE_APP_BACKEND_API_URL + "/api/avis_crop/" + id;
    const response = await axios.get(url);
    return response.data;
  },
  async new(avis_crop) {
    const url = process.env.VUE_APP_BACKEND_API_URL + "/api/avis_crops";
    const response = await axios.post(url, avis_crop);
    return response.data;
  },
  async update(id, avis_crop) {
    const url = process.env.VUE_APP_BACKEND_API_URL + "/api/avis_crop/" + id;
    const response = await axios.put(url, avis_crop);
    return response.data;
  }
};
